const DATE_REGEX = /^\d{4}\-(0?[1-9]|1[012])\-(0?[1-9]|[12][0-9]|3[01])$/;

export const validateDate = (date: string | undefined | null) => {
  if (date === null || date === undefined) {
    return false;
  }

  return typeof date === "string" && date.match(DATE_REGEX);
};
